import React from 'react'
import PropType from 'prop-types'
import Fab from '@material-ui/core/Fab'

const FabAdapter = ({
  isExtended,
  children,
  disabled,
  onClick,
  type,
  className,
}) => (
  isExtended
    ? (
      <Fab
        variant="extended"
        disabled={disabled}
        color="primary"
        onClick={onClick}
        className={className}
        type={type}
      >
        { children }
      </Fab>
    )
    : (
      <Fab
        color="primary"
        disabled={disabled}
        onClick={onClick}
        className={className}
        type={type}
      >
        { children }
      </Fab>
    )
)

FabAdapter.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  onClick: () => null,
  type: 'button',
  isExtended: false,
}

FabAdapter.propTypes = {
  children: PropType.node,
  className: PropType.string,
  disabled: PropType.bool,
  onClick: PropType.func,
  type: PropType.string,
  isExtended: PropType.bool,
}

export default FabAdapter
